import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { FileExportService } from '@shared/services/file-export/services/file-export.service';

import { SelectItemsToExportModalComponent } from './select-items-to-export-modal/select-items-to-export-modal.component';

@Component({
    selector: 'app-export-to-selector',
    templateUrl: './export-to-selector.component.html',
    styleUrls: ['./export-to-selector.component.scss'],
    standalone: true,
    imports: [MatButton, MatIcon]
})
export class ExportToSelectorComponent {
  @Input() isDisabled = false;
  @Output() protected buttonClicked = new EventEmitter<boolean>();

  constructor(
    public dialog: MatDialog,
    private fileExportService: FileExportService
  ) {}

  protected selectItemsToExport() {
    this.dialog.open(SelectItemsToExportModalComponent, {
      width: '80vw',
      height: '100vh',
      maxWidth: '80vw',
      maxHeight: '100vh',
      position: { right: '0' },
      panelClass: 'select-items-to-export-modal',
      hasBackdrop: true,
      disableClose: false,
    });
  }

  protected exportTestPdf() {
    const testData = {
      driver: 'html2pdf' as const,
      pages: [], // No pages needed - HTML to PDF driver has test content built-in
      options: {
        pageNumber: false,
        headerLogo: false,
        confidentialityClause: false,
        confidentialityClauseText: '',
      },
    };

    this.fileExportService.getFile(testData, 'cTTP-study-report');
  }
}
